// extracted by mini-css-extract-plugin
export default {"subscription":"SubscriptionText_subscription__W2thR","title":"SubscriptionText_title__vnSnX","subtitle":"SubscriptionText_subtitle__uwdx8"};